import { render, staticRenderFns } from "./ManterReserva.vue?vue&type=template&id=2ba0446f&"
import script from "./ManterReserva.vue?vue&type=script&lang=js&"
export * from "./ManterReserva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports